/**
 * Created by wuhuping on 2017/7/10.
 */
import store from '../store'
import router from '../router'
import Vue from 'vue'
export default {
  checkLogin(resource, redirectUrl) {
    // Vue.$vux.confirm.show({
    //   content: '<html> <div>【享宇钱包】已正式升级更名为【金融苑】</div> <div>产品更多、贷款更快</div> 请前往下载金融苑 </html>',
    //   confirmText: '立即下载',
    //   cancelText: '取消',
    //   onCancel() {
    //   },
    //   onConfirm() {
    //     window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=xybank.com.rainbowcredit'
    //   }
    // })
    return new Promise((resolve) => {
      if (store.getters.isLogin) {
        resolve()
      } else {
        var query = {}
        if (resource) {
          query.resource = resource
        }
        if (redirectUrl) {
          query.redirectUrl = redirectUrl
        }
        router.push({'name': 'quickLogin', query: query})
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/tools/loginChecker.js